import React from "react";

import { PhoneLayout } from "@/features/previews/layouts/PhoneLayout";
import { Mp3Header, Mp3AudioContent, Mp3ContentInfo, Mp3SocialSection } from "./components";
import { PreviewPrimaryAction } from "@/features/previews/shared/components/PreviewPrimaryAction";

import type { QRProps } from "@/contexts/QREditorContext/types";
import { useMp3Data } from "./hooks/useMp3Data";

import "./styles.scss";

export const Mp3Template = (props: QRProps<"mp3">) => {
  const {
    isInitialPreview,
    data,
    showQrContentWrapper,
    hasDownloadButton,
    hasShareButton,
    hasAudioFile,
    hasCustomButton,
  } = useMp3Data(props);

  if (!data) {
    return null;
  }

  return (
    <PhoneLayout
      page="mp3"
      dataQA="preview-mp3-container"
      backgroundColor={data?.themeColor?.backgroundColor}
      isInitPreview={isInitialPreview}
      hasIncludeBrowser
    >
      <div className="mp3-template">
        <Mp3Header
          data={data}
          isInitialPreview={isInitialPreview}
          hasDownloadButton={hasDownloadButton}
          hasShareButton={hasShareButton}
        />

        {showQrContentWrapper && (
          <div className="mp3-template__info">
            <Mp3ContentInfo data={data} />
            <Mp3AudioContent
              data={data}
              isInitialPreview={isInitialPreview}
              hasAudioFile={hasAudioFile}
            />
          </div>
        )}

        {hasCustomButton && (
          <PreviewPrimaryAction
            dataQA="preview-mp3-button"
            text={data?.mp3ButtonText}
            url={data?.mp3ButtonUrl}
            buttonColor={data?.themeColor?.buttonColor}
            className="mp3-template__custom-button"
          />
        )}

        <Mp3SocialSection
          data={data}
          isInitialPreview={isInitialPreview}
        />
      </div>
    </PhoneLayout>
  );
};
